<template>
  <div class="cb-item cb-transition__tab" :style="themeColor">
    <div class="cb-item__group">
      <div class="cb-item__sub-group">
        <div class="cb-item__price cb-item__sub-group--right">
          <span class="cb-item__middle">
            {{ amount | cbCurrency(currencyCode) }}
          </span>
          <span class="cb-item__price--info" v-if="singleCart && chargedQuantity > 1" v-cb-html="sanitizeTags(priceInfo, [])"></span>
        </div>
        <div class="cb-item__name  cb-item__sub-group--left">
          {{ name }} <span v-if="showQuantityReadOnly"><i class=" cb-item__icon-remove">&times;</i> {{quantity}}</span> <span v-if="nonRecAddonTag" class="cb-label cb-label-recur" :style="backgroundColor">{{ct('non_rec_addon.tag')}}</span>
        </div>
        <div class="cb-item__desc" v-if="singleCart && description" v-cb-html="sanitizeTags(description, ['BR'])">
        </div>
      </div>
      <div class="cb-item__sub-group" v-if="(canShowQuantity || canShowRemove)">
        <quantity-template v-if="canShowQuantity" :quantity="quantity" @input="updateQuantity" :meta="quantityMeta" :initial-quantity="getInitialQuantity"/>
        <div class="cb-item__action cb-item__remove cb-item__sub-group--inline" v-if="canShowRemove">
          <span @click="remove()" v-cb-link="'color'">{{ct('cart.remove')}}</span>
        </div>
      </div>
      <item-description :singleCart='singleCart' :item='item' :currencyCode='currencyCode'></item-description>
    </div>
  </div>
</template>
<script type="text/javascript">
import CartHelper from '@/utils/cart-helper'
import TierHelper from '@/utils/lineitem-tier-helper'
import Quantity from "@/components/modules/hosted-pages/Quantity"
import ItemDescription from "@/components/modules/hosted-pages/ItemDescription"
import {
  mapGetters
} from 'vuex'
export default {
  props: ['item', 'singleCart', 'readonly', 'currencyCode', 'useItem', 'singleItem'],
  components: {
    'quantity-template': Quantity,
    'item-description': ItemDescription
  },
  methods: {
    ...CartHelper,
    updateQuantity(value) {
      if (value != this.quantity) {
        this.$store.dispatch('set_loader', true);
        var q = this.quantity;
        this.$store.dispatch('update_quantity', {
          item: this.item,
          value: value
        }).then(() => {
          this.$store.dispatch('set_loader', false);
        }).catch((error) => {
          // TODO show error
          //revisit logic
          // if(error._source.error_code == "amount_overflow" || error._source.error_code == "wrong_format"){
            this.$store.dispatch('update_quantity', {
              item: this.item,
              value: q
            })
          // }
          this.$store.dispatch('set_loader', false);
          this._displayErrorMessage(error,false);
          logger.e(error);
        });
      }
    },
    _displayErrorMessage(error, skipNotificationSetting) {
      if (!skipNotificationSetting) {
        this.$store.dispatch('set_current_notification', {
          type: 'error',
          message: error.message
        });
      }
    },
    remove() {
      this.$store.dispatch('remove_item', this.item);
    },
    sanitizeTags(content, allowedTags){
      return {
        text: content,
        tags: allowedTags,
        attrs: []
      }
    }
  },
  computed: {
    ...mapGetters(['ui_config', 'is_cart_with_estimate']),
    lineItem() {
      return this.useItem ? undefined : this.item.lineItem;
    },
    amount() {
      return this.lineItem ? this.lineItem.amount : this.item.amount;
    },
    unitAmount() {
      return this.lineItem ? this.lineItem.unit_amount : this.item.unit_amount;
    },
    description() {
      return this.item.details && this.item.details.description;
    },
    name() {
      return this.lineItem ? this.lineItem.description : (this.item.details && (this.item.details.invoice_name || this.item.details.name));
    },
    nonRecAddonTag() {
      return !this.singleItem && this.useItem && this.item.type == "addon" && this.item.charge_type == "non_recurring";
    },
    quantity() {
      return parseInt(this.item.quantity || 0);
    },
    chargedQuantity() {
      var output = this.lineItem ? this.lineItem.quantity : (this.quantity - this.freeQuantity);
      return parseInt(output);
    },
    freeQuantity() {
      return parseInt(this.item.free_quantity || 0);
    },
    quantityMeta() {
      return this.ui_config["hp_v3.quantity.custom_selection"] && (this.item.quantity_meta_overrides || (this.item.details.meta_data && this.item.details.meta_data.quantity_meta));
    },
    getInitialQuantity() {
      return this.quantityMeta && this.quantityMeta.allow_only_upgrade ? (this.item.initialQuantity || 0) : 0;
    },
    canShowQuantity() {
      return !this.readonly && CartHelper.canShowQuantity(this.item, this.$store.getters);
    },
    canShowRemove() {
      return !this.readonly && !this.singleItem && CartHelper.canRemove(this.item, this.$store.getters);
    },
    showQuantityReadOnly() {
      return !this.singleCart && this.quantity > 1 && !this.canShowQuantity;
    },
    priceInfo() {
      let helper = TierHelper.getTierConstructor(this.item, this.currencyCode, this.$store.getters);
      let info = helper.constructPriceInfo();
      if(!info) {
        info = helper.quantityDesc(this.unitAmount, this.chargedQuantity, false);
      }
      return "&#40;" + info + "&#41;"
    }
  }
}
</script>
<style lang="stylus" scoped>
.cb-label-recur{
  margin: 3px;
}
</style>


// WEBPACK FOOTER //
// LineItem.vue?1fa6dfc6